import { useEffect, useMemo, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Stack, useTheme } from '@mui/material';
import { IObject } from 'src/models/objectManagement';
import SelectObjectSection from '../ModalManageObjectRetail/components/SelectObjectSection';
import { useAppSelector } from 'src/app/hooks';
import { useLocation } from 'react-router';

interface Props {
  open: boolean;
  onClose: () => void;
  objectList: Array<IObject>;
  onDone: (selectedKeywordIds: Array<string>) => void;
  loading?: boolean;
}

const ModalAddHashtagToCampaignRetail: React.FC<Props> = ({
  open,
  onClose,
  objectList,
  onDone,
  loading
}) => {
  const theme = useTheme();

  const objectListKeywordAndHashtag = useMemo((): Array<IObject> => {
    return objectList.filter((object) => object.isHashtag);
  }, [objectList]);

  const { pathname } = useLocation();
  const mainPath = pathname.split('/')[1];
  const isGoogleReview = mainPath === 'google_review';

  const objectIdList = useAppSelector(
    (state) => state.analyticArguments.objectIdList
  );

  const activeObjectIds = useMemo(() => {
    const objectIdListSet = new Set(objectIdList);
    return objectList.filter((object) => objectIdListSet.has(object.id));
  }, [objectIdList]);

  const [selectedObjectIds, setSelectedObjectIds] = useState<Array<string>>([]);

  useEffect(() => {
    setSelectedObjectIds(activeObjectIds.map((item) => item.id));
  }, [activeObjectIds]);

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth={'md'}>
      <Stack height="380px" direction="row" sx={{ p: 4, gap: 1 }} width="100%">
        <SelectObjectSection
          objectList={objectListKeywordAndHashtag}
          activeObjectIdList={selectedObjectIds}
          selectedTab="hashtag"
          setSelectedTab={null}
          tabList={[
            {
              label: 'Hashtag',
              value: 'hashtag'
            }
          ]}
          onSelectObject={(objectIds: string[]) =>
            setSelectedObjectIds(objectIds)
          }
          isGoogleReview={isGoogleReview}
          isEditing={false}
          isStreamPanel={false}
          handleDone={() => onDone(selectedObjectIds)}
          disableSubmit={loading}
          isCustomDashboard={false}
        />
      </Stack>
    </Dialog>
  );
};

export default ModalAddHashtagToCampaignRetail;
